function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var GameCardfanTemplate = require('./game-cardfan.template');

/**
 * GameCardFan is a tool for displaying a hand of cards, fanned out so all the cards are overlapping but visible
 * The main utility is in the css for fanning the cards out in a visually pleasing layout, which can also be accessed by just using the "cardfan" class in the container of "card"-classed items
 * cardFan is included by default in gameTemplate and is accessible through .cardfan in the inheriting game module
 * cardFan should only be rendered when needed and only one card fan can exist on the screen at a time.
 * The Game module should provide detailed html for the cards to be displayed in the fan, otherwise by default render
 * makes strong assumptions about the data structure of your game module
 *
 */
var GameCardfan = /*#__PURE__*/function () {
  /**
   * @constructor stores a reference to the Saito app
   * @param app - the Saito application
   * @param mod - the game module
   */
  function GameCardfan(app, mod) {
    _classCallCheck(this, GameCardfan);
    this.app = app;
    this.game_mod = mod;
    this.container = '';
    this.el = null;
  }

  /**
   * Adds a cardfan div to the DOM if it does not already exist and populates it with the
   * provided card html. If no card html is provided, card fan queries the hand in deck one
   * and creates an html template assuming card images are in the directory specified in mod.card_img_dir
   * and appropriately named (when creating the deck)
   */
  return _createClass(GameCardfan, [{
    key: "render",
    value: function render() {
      var _this = this;
      var cards_html = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      if (!this.game_mod.gameBrowserActive()) {
        return;
      }
      if (!this.game_mod.game.player) {
        return;
      }
      try {
        if (!document.getElementById('cardfan')) {
          if (this.container) {
            this.app.browser.addElementToSelector(GameCardfanTemplate(), this.container);
          } else {
            this.app.browser.addElementToDom(GameCardfanTemplate());
          }
          this.attachEvents();
        }
        this.el = document.getElementById('cardfan');
        if (cards_html === '') {
          var _this$game_mod$game$d = this.game_mod.game.deck[0],
            cards = _this$game_mod$game$d.cards,
            hand = _this$game_mod$game$d.hand;
          var cards_in_hand = hand.map(function (key) {
            return cards[key];
          });
          cards_html = cards_in_hand.map(function (card) {
            return "<img class=\"card\" src=\"".concat(_this.game_mod.card_img_dir, "/").concat(card.name, "\">");
          }).join('');
        }
        if (cards_html) {
          this.el.innerHTML = cards_html;
        }
        this.el.style.display = 'block';
      } catch (err) {}
    }

    /**
     * Makes the cardFan draggable
     */
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      //if (!this.container) {
      this.app.browser.makeDraggable('cardfan');
      //}
    }

    //** Show the card fan */
  }, {
    key: "show",
    value: function show() {
      try {
        if (this.el) {
          this.el.style.display = 'block';
        }
      } catch (err) {
        console.error(err);
      }
    }

    //** Hide the card fan */
  }, {
    key: "hide",
    value: function hide() {
      try {
        if (this.el) {
          this.el.style.display = 'none';
        }
      } catch (err) {
        console.error(err);
      }
    }

    /**
     * Sets a class name for the cardFan to facilitate customization of display
     * @param classname {string} - the class name
     */
  }, {
    key: "addClass",
    value: function addClass(classname) {
      try {
        if (this.el && !this.el.classList.contains(classname)) {
          this.el.classList.add(classname);
        }
      } catch (err) {
        console.error(err);
      }
    }

    /**
     * Removes a class name for the cardFan to facilitate customization of display
     * @param classname {string} - the class name
     */
  }, {
    key: "removeClass",
    value: function removeClass(classname) {
      try {
        if (this.el && this.el.classList.contains(classname)) {
          this.el.classList.remove(classname);
        }
      } catch (err) {
        console.error(err);
      }
    }

    /**
     * Inserts the html for a single card into the start of the fan (left side)
     * @param app - the Saito application
     * @param mod - the game module
     * @param cards_html - html specification of the card to be addedf
     */
  }, {
    key: "prependCard",
    value: function prependCard() {
      var cards_html = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      if (cards_html !== '') {
        if (this.el) {
          this.el.innerHTML = cards_html + fan.innerHTML;
        }
      }
    }

    /**
     * Inserts the html for a single card into the end of the fan (right side)
     * @param app - the Saito application
     * @param mod - the game module
     * @param cards_html - html specification of the card to be addedf
     */
  }, {
    key: "addCard",
    value: function addCard() {
      var cards_html = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      if (cards_html !== '') {
        if (this.el) {
          this.el.innerHTML += cards_html;
        }
      }
    }
  }]);
}();
module.exports = GameCardfan;